// extracted by mini-css-extract-plugin
module.exports = {"time":"time__G5CIK","timelineMainStarting":"timelineMainStarting__Wdyj1","timelineMain":"timelineMain__2NEyy","timelineWrap":"timelineWrap__kUxBA","scrollDate":"scrollDate__dnNDg"};